import React from "react";
import { Typography } from '@mui/material';

export function CustomerName(props) {
    return (
        <Typography display="inline" {...props}>{props.prefix} {`${props.customer?.profile?.firstName} ${props.customer?.profile?.lastName}`} </Typography>
    )
}